'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MetricsCollector = function () {
  function MetricsCollector(storage) {
    (0, _classCallCheck3.default)(this, MetricsCollector);

    this.storage = storage;

    this.latency = this.latency.bind(this);
    this.count = this.count.bind(this);
    this.countException = this.countException.bind(this);
  }

  (0, _createClass3.default)(MetricsCollector, [{
    key: 'latency',
    value: function latency(ms) {
      this.storage.metrics.track(this.metricType + '.time', ms);
    }
  }, {
    key: 'count',
    value: function count(status) {
      this.storage.count.track(this.metricType + '.status.' + status);
    }
  }, {
    key: 'countException',
    value: function countException() {
      this.storage.count.track(this.metricType + '.exception');
    }
  }]);
  return MetricsCollector;
}();

var SegmentChangesCollector = function (_MetricsCollector) {
  (0, _inherits3.default)(SegmentChangesCollector, _MetricsCollector);

  function SegmentChangesCollector(storage) {
    (0, _classCallCheck3.default)(this, SegmentChangesCollector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SegmentChangesCollector.__proto__ || (0, _getPrototypeOf2.default)(SegmentChangesCollector)).call(this, storage));

    _this.metricType = 'segmentChangeFetcher';
    return _this;
  }

  return SegmentChangesCollector;
}(MetricsCollector);

var SplitChangesCollector = function (_MetricsCollector2) {
  (0, _inherits3.default)(SplitChangesCollector, _MetricsCollector2);

  function SplitChangesCollector(storage) {
    (0, _classCallCheck3.default)(this, SplitChangesCollector);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (SplitChangesCollector.__proto__ || (0, _getPrototypeOf2.default)(SplitChangesCollector)).call(this, storage));

    _this2.metricType = 'splitChangeFetcher';
    return _this2;
  }

  return SplitChangesCollector;
}(MetricsCollector);

var MySegmentsCollector = function (_MetricsCollector3) {
  (0, _inherits3.default)(MySegmentsCollector, _MetricsCollector3);

  function MySegmentsCollector(storage) {
    (0, _classCallCheck3.default)(this, MySegmentsCollector);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (MySegmentsCollector.__proto__ || (0, _getPrototypeOf2.default)(MySegmentsCollector)).call(this, storage));

    _this3.metricType = 'mySegmentsFetcher';
    return _this3;
  }

  return MySegmentsCollector;
}(MetricsCollector);

var SDKCollector = function () {
  function SDKCollector(storage) {
    (0, _classCallCheck3.default)(this, SDKCollector);

    this.storage = storage;

    this.ready = this.ready.bind(this);
    this.latency = this.latency.bind(this);
  }

  (0, _createClass3.default)(SDKCollector, [{
    key: 'ready',
    value: function ready(ms) {
      this.storage.metrics.track('sdk.ready', ms);
    }
  }, {
    key: 'latency',
    value: function latency(ms) {
      this.storage.metrics.track('sdk.getTreatment', ms);
    }
  }]);
  return SDKCollector;
}();

module.exports = {
  SegmentChangesCollector: SegmentChangesCollector,
  SplitChangesCollector: SplitChangesCollector,
  MySegmentsCollector: MySegmentsCollector,
  SDKCollector: SDKCollector
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/metrics/Collectors.js
// module id = 694
// module chunks = 10